let actionsArray = [];
let types = {};

export function getTypes() {
  return types;
}

export function setActionTypes(actions, mutateWith = ['Request', 'Error']) {
  if (!actionsArray.length) {
    actionsArray = Object.keys(actions);

    types = actionsArray.reduce((res, cur) => {
      res[cur] = cur;

      mutateWith.forEach(e => {
        const key = cur + e;
        res[key] = key;
      });

      return res;
    }, {});

    if (typeof window !== 'undefined') {
      window.types = types;
    }
  }

  return actionsArray;
}

export function simpleActions(actions, mutateWith) {
  /* eslint-disable */
  const actionsArray = setActionTypes(actions, mutateWith);

  actionsArray.forEach(key => {
    let action = actions[key];
    actions[key] = function() {
      if (!action) {
        console.warn(`The action ${key} should return Object or Promise`);
        action = {};
      }

      if (action.type) {
        types[key] = action.type;
      }

      return Object.assign(action.apply(this, arguments), {
        type: action.type || key,
      });
    };
  });
  /* eslint-enable */

  return actions;
}



// WEBPACK FOOTER //
// ./src/store/actions-wrapper.js